<template>
    <BFormInput
        :state="input_state"
        :value="value"
        v-bind="$attrs"
        v-on="inputListeners"
    ></BFormInput>
</template>

<script>
import { BFormInput } from "bootstrap-vue";
import VuexInputFieldMixin from "./VuexInputFieldMixin.js";

export default {
    name: "OTextInput",
    components: {
        BFormInput,
    },
    mixins: [VuexInputFieldMixin(false)],
};
</script>

<style scoped></style>
